import { isEmpty } from 'lodash'
import { useCallback } from 'react'

const useTimelineVideoPlayerAssetsProps = ({
  playingMediaAssets,
  rect,
  onMounted,
  onBufferingProgress,
  transitionVideoAsset,
  composedMediaAssets,
  videoRefs,
  isPlaying,
  restAggregatedPlayerProps,
}) => useCallback((asset, isBackground = false, isComposed = false) => {
  const { id, width, height } = asset

  const assetIndex = playingMediaAssets.findIndex(a => a.id === asset.id)
  const aspectRatio = width / (height || 1) // determine the original aspect ratio
  const isActive = !!playingMediaAssets.find(a => a.id === id)
  const isPrimary = (composedMediaAssets?.[0]?.id === id)
    || (isActive && playingMediaAssets[0].id === id && isEmpty(composedMediaAssets))

  let playerAssetProps = {
    ...restAggregatedPlayerProps,
    asset,
    key: id,
    id: asset.id,
    playing: isPlaying,
    width: rect.width,
    height: rect.width / (aspectRatio || 1), // sizing preview height to original ratio
    // play only audio track from video assets placed under the top video
    playAudioOnly: playingMediaAssets.filter((_, i) => i < assetIndex)
      .some(a => !a?.settings?.isChromaKeyEnabled),
    onReady: () => {},
    onMounted,
    onBufferingProgress,
    // NOTE: Listen progress callback from longest active asset (including transition asset) after slider time
    isBackground: false,
    active: isActive,
    isPrimary,
    videoRef: videoRefs[id],
    isComposed,
  }
  if (isBackground) {
    playerAssetProps = {
      ...playerAssetProps,
      playing: false,
      style: { opacity: 0 },
      isBackground: true,
    }
  }
  // NOTE: hidding both videos while transition
  if (transitionVideoAsset?.id) {
    playerAssetProps = {
      ...playerAssetProps,
      style: { opacity: 0 },
    }
  }

  return playerAssetProps
}, [
  playingMediaAssets,
  rect,
  onMounted,
  onBufferingProgress,
  transitionVideoAsset,
  videoRefs,
  isPlaying,
  restAggregatedPlayerProps,
  composedMediaAssets,
])

export default useTimelineVideoPlayerAssetsProps
